import React from "react";
import { ArrowRight, PlayCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import HeroVisual from "@/components/landing/HeroVisual";

export default function Hero() {
  const { t } = useLang();

  return (
    <section id="top" className="relative pt-28 md:pt-32 lg:pt-40 pb-16 md:pb-24 overflow-hidden" data-testid="hero-section">
      {/* Ambient background */}
      <div aria-hidden className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-white via-brand-paper to-white" />
        <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full bg-brand-champagneSoft/30 blur-[140px]" />
      </div>

      <div className="container-x grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7 animate-fade-up">
          <span className="overline inline-flex items-center gap-2">
            <span className="h-1 w-6 bg-brand-champagne rounded-full" />
            {t.hero.eyebrow}
          </span>

          <h1 className="mt-6 text-4xl sm:text-5xl lg:text-[68px] leading-[1.02] font-semibold tracking-tight text-brand-ink text-balance">
            {t.hero.h1a}
            <br />
            <span className="relative inline-block">
              <span className="relative z-10">{t.hero.h1b}</span>
              <span className="absolute left-0 right-0 bottom-1 h-[12px] bg-brand-champagneSoft/70 -z-0 rounded" aria-hidden />
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-base md:text-lg text-brand-graphite/90 leading-relaxed text-pretty">
            {t.hero.sub}
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a href="/#contact" className="btn-primary" data-testid="hero-cta-primary">
              {t.hero.cta1}
              <ArrowRight className="h-4 w-4" />
            </a>
            <a href="/#how" className="btn-ghost" data-testid="hero-cta-secondary">
              <PlayCircle className="h-4 w-4" />
              {t.hero.cta2}
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-4 md:gap-8 max-w-lg">
            {[t.hero.metric1, t.hero.metric2, t.hero.metric3].map((m, i) => (
              <div key={i} className="border-l border-brand-mist pl-4">
                <div className="font-heading text-2xl md:text-3xl font-semibold text-brand-ink">
                  {["7s", "0", "NFC+QR"][i]}
                </div>
                <div className="mt-1 text-xs md:text-sm text-brand-stone leading-snug">
                  {m}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <HeroVisual />
        </div>
      </div>
    </section>
  );
}
